import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ABService {

  private readonly getCached = (key: string) => typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(key) : undefined;

  private readonly sessionCached = new Set([
    'pg_paypal_AB'
  ]);

  readonly values = {
    slab_AB: signal<any>(undefined),
    pg_paypal_AB: signal<any>(undefined),
    story_image_AB: signal<any>(undefined),
    ty_sip_amt_AB: signal<any>(undefined),
    thank_you_AB: signal<any>(undefined),
    exit_intent_AB: signal<any>(undefined),
    hide_email_AB: signal<any>(undefined)
  };

  constructor() {
    if (typeof window === 'undefined') return;
    Object.keys(this.values).forEach(key => {
      let value = (globalThis as any)[key] ?? undefined;
      if (value === undefined && this.sessionCached.has(key)) {
        value = this.getCached(key) ?? undefined;
      }
      if (value !== undefined) this.values[key as keyof typeof this.values].set(value);
      Object.defineProperty(globalThis, key, {
        configurable: true,
        enumerable: true,
        get: () => value,
        set: (v) => {
          value = v;
          this.values[key as keyof typeof this.values].set(v);
          if (this.sessionCached.has(key) && value !== undefined && typeof sessionStorage !== 'undefined') sessionStorage.setItem(key, value ?? '');
        }
      });
    });
  }

}
